var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"arrow"},[(!_vm.isShow)?_c('img',{attrs:{"src":require("../../../assets/images/winterGame/arrDown.png")}}):_c('img',{attrs:{"src":require("../../../assets/images/winterGame/arrUp.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }